import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import Logo from "./../logo/Logo";
import { SurveyContext } from "../../store/survey-context";
import CtaBackDashboard from "../ctaBackDashboard/ctaBackDashboard";
import "./header.scss";

export default function Header() {
  const context = useContext(SurveyContext);
  const { ready } = useTranslation("common", { useSuspense: false });

  if (!ready) return null;

  return (
    <header className="header__container">
      <div className="header">
        <Logo onClick={() => context.setDialogOpen(true)} />
      </div>

      {(!context.showSurvey || context.error !== false) && (
        <CtaBackDashboard
          onClick={() => context.setDialogOpen(true)}
          showOnLargeScreen={true}
        />
      )}
    </header>
  );
}
